import React from 'react'
import { useHistory } from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import CloseOutlinedIcon from 'components/material-symbol/icons/Close'
import SocialShareDialog from 'components/social-share-dialog'
import { useStyles } from './styles'

const ActionButtons = ({ setIsOpen, event, canEdit }) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <Box className={classes.actionButtonContainer}>
      <SocialShareDialog
        trigger={
          <Avatar className={classes.actionAvatar} aria-label="Link">
            <LinkOutlinedIcon color="primary" />
          </Avatar>
        }
        shareUrl={event.eventUrl}
        shareTitle={event.title}
        dialogTitle="Share event link"
        dialogSubtitle="Let students register directly from this link."
        showBookingUrl
        att="pga-group-event"
        shareId={event.id}
      />
      {canEdit ? (
        <Avatar
          className={classes.actionAvatar}
          onClick={() =>
            history.push(`/pga-coach/bookings/events/edit/${event.slug}`)
          }
        >
          <EditOutlinedIcon color="primary" />
        </Avatar>
      ) : null}
      <Avatar className={classes.actionAvatar} onClick={e => setIsOpen(false)}>
        <CloseOutlinedIcon color="primary" />
      </Avatar>
    </Box>
  )
}

export default ActionButtons
